import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { FilterOptions, GetOptions, PaginationOptions, RequestConfig } from 'api/types';
import type { OnlineAdviceRequestsFilters } from 'constants/onlineAdviceRequestsFilters';

export type ClientOnlineAdviceRequestsGetOptions = GetOptions &
  PaginationOptions &
  FilterOptions<OnlineAdviceRequestsFilters>;

export function clientOnlineAdviceRequestsApi(path: string) {
  return {
    path,
    GET: (params: ClientOnlineAdviceRequestsGetOptions = {}, config?: RequestConfig) => {
      const { pageSize, pageNumber, ...rest } = params;

      return api.get<JsonApiResponse>(path, {
        params: {
          per_page: pageSize,
          page: pageNumber,
          ...rest,
        },
        ...config,
      });
    },
  };
}
